import {handleFirstJSError} from "../blink-sdk/utils/AnalyticsClient";

// TODO @Mihai figure out how to better insert this
window.onerror = handleFirstJSError;

export {WebsiteApp} from "./website/WebsiteApp";
export {AutomationHelper} from "./AutomationHelper";
export * from "./State";
